<template>
  <!-- document dialog -->
  <v-dialog
    v-model="isOpen"
    width="550px"
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-file-document-outline</v-icon
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertDocument.addEditDoc'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon dark @click="checkToSave" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertDocument.close'
            )
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="beforeValidate">
          <!-- <v-row justify="center" class="rowContentmange"> -->
          <!-- <v-col cols="6" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertDocument.docName'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                outlined
                :rules="nameRules"
                clearable
                class="textField"
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertDocument.docName'
                  )
                "
                v-model="title"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertDocument.detail'
                  )
                }}
              </p>
              <v-textarea
                v-model="description"
                :label="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertDocument.detail'
                  )
                "
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertDocument.detail'
                  )
                "
                full-width
                outlined
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <p class="title mb-0">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertDocument.perMissionDownload'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <div class="d-flex align-center">
                <v-radio-group
                  v-model="canDownload"
                  mandatory
                  row
                  hide-details="auto"
                >
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertDocument.noDownload'
                      )
                    "
                    :value="false"
                  ></v-radio>
                  <v-radio
                    :label="
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertDocument.canDownload'
                      )
                    "
                    :value="true"
                  ></v-radio>
                </v-radio-group>
              </div>
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- <v-col cols="5" lg="5" md="5" sm="11" xs="11"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertDocument.docFile'
                  )
                }}
                <span class="red--text">*</span>
                <span class="subtitle-1">{{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertDocument.docFileInstruction'
                  )
                }}</span>
              </p>
              <v-file-input
                :rules="fileRules"
                v-model="documentFile"
                counter
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertDocument.chooseFile'
                  )
                "
                @change="onFileChange"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
                accept=".pdf"
                @click:clear="clearPreview"
              >
                <template v-slot:selection="{ index, text }">
                  <p class="mb-0">{{ text }}</p>
                  <!-- <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>{{ text }}</v-chip> -->

                  <span
                    v-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                    >+{{ files.length - 2 }}
                    {{
                      this.$vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.insertDocument.files'
                      )
                    }}</span
                  >
                </template>
              </v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="examplePDF">
              <!-- <label class="title">{{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertDocument.sample'
                )
              }}</label> -->
              <!-- <br /> -->
              <div v-if="!urlPDF" v-show="urlPDF">
                <!-- {{ pdfCurrentPage }} / {{ pdfCountPage }} -->
                <pdf
                  :src="urlPDF"
                  @num-pages="pdfCountPage = $event"
                  @page-loaded="pdfCurrentPage = $event"
                ></pdf>
              </div>
              <iframe class="iframePDF" :src="urlPDF"></iframe>
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- </v-row> -->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
          outlined
          @click="checkToSave"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.cancel'
            )
          }}</v-btn
        >
        <v-btn
          elevation="0"
          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
          @click="beforeValidate"
          :loading="loadingBtn"
          :disabled="!isValid()"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.save'
            )
          }}</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog v-model="warnningToSaveDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
          )
        }}</v-card-title>
        <v-card-text>{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
          )
        }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="closeLectureDialog"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.exit'
                )
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { insertLecture, updateLecture } from '@/service/course/course.js';
import { headersWithTokenForImage, domain } from '@/service/configApi';
import { getPrivatePdf } from '@/service/upload/upload.js';
import axios from 'axios';
import pdf from 'vue-pdf';
import { EventBus } from '../../../event-bus';
export default {
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reload: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
    closeLectureDialog: {
      type: Function,
    },
  },
  components: {
    pdf,
  },
  data() {
    return {
      numPages: undefined,
      pdfCurrentPage: 0,
      pdfCountPage: 0,
      valid: true,

      title: '',
      description: '',
      urlPDF: '',

      nameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertDocument.pleaseFillName'
          ),
      ],
      successUpload: true,
      pdfUploadId: '',
      documentFile: null,

      // Edit
      oldFileId: '',
      oldFileUrl: '',

      //check to save
      oldValue: [],
      warnningToSaveDialog: false,
      pdfFile: null,
      canDownload: false,
      loadingBtn: false,
    };
  },
  computed: {
    fileRules() {
      const rules = [];

      if (this.lectureId === undefined) {
        const rule = (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertDocument.pleaseFillDetail'
          );

        rules.push(rule);
      }

      return rules;
    },
  },
  watch: {
    // whenever question changes, this function will run
    // lectureId: async function(newValue, oldValue) {
    //   console.log(newValue, oldValue, this.lectures);
    //   let filterLecture = this.lectures.filter(
    //     lecture => lecture._id === newValue
    //   )[0];
    //   console.log(filterLecture);
    //   this.title = filterLecture.title;
    //   this.description = filterLecture.description;
    //   console.log(filterLecture.pdf[0]);
    //   let resultLink = await getPrivatePdf(filterLecture.pdf[0]._id);
    //   console.log(resultLink);
    //   this.urlPDF = resultLink;
    //   this.oldFileId = filterLecture.pdf[0]._id;
    //   this.oldFileUrl = resultLink;
    //   this.successUpload = true;
    // },
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.lectureId) {
          let filterLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          this.title = filterLecture.title;
          this.description = filterLecture.description;
          let resultLink = await getPrivatePdf(filterLecture.pdf[0]._id);
          this.urlPDF = resultLink;
          this.documentFile = null;
          this.oldFileId = filterLecture.pdf[0]._id;
          this.oldFileUrl = resultLink;
          this.successUpload = true;
          (this.oldValue = filterLecture), (this.pdfFile = null);
          this.canDownload = filterLecture.isDownload;
          this.loadingBtn = false
        } else {
          this.title = '';
          this.description = '';
          this.documentFile = null;
          this.urlPDF = '';
          this.successUpload = true;
          this.pdfUploadId = '';
          this.pdfFile = null;

          // Edit
          this.oldFileId = '';
          this.oldFileUrl = '';
          this.canDownload = false;
          this.loadingBtn = false
          if (this.$refs.form) {
            this.$refs.form.reset();
          }
        }
      }
    },
  },
  methods: {
    isValid() {
      // return this.valid && this.successUpload;
      return this.valid;
    },
    async beforeValidate() {
      await this.setLoadingBtn()
      if (this.pdfFile != null) {
        await this.uploadFile(this.pdfFile);
      } else {
        await this.validate();
      }
      await this.unsetLoadingBtn()
    },
    async setLoadingBtn() {
      this.loadingBtn = true;
    },
    async unsetLoadingBtn() {
      this.loadingBtn = false;
    },
    async validate() {
      this.warnningToSaveDialog = false;
      if (this.$refs.form.validate() && this.successUpload) {
        if (!this.lectureId) {
          await insertLecture({
            id: this.sectionId,
            title: this.title,
            description: this.description,
            type: 'PDF',
            pdf: [this.pdfUploadId],
            isDownload: this.canDownload,
          });

          // let newLectures = this.lectures.map(lecture => lecture._id);
          // newLectures.push(result._id);

          this.reload();
          this.closeDialog();

          EventBus.$emit('creditPoint.show');
        } else {
          let currentLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          let result = await updateLecture({
            ...currentLecture,
            id: this.lectureId,
            title: this.title,
            description: this.description,
            type: 'PDF',
            pdf: this.pdfUploadId ? [this.pdfUploadId] : [this.oldFileId],
            isDownload: this.canDownload,
          });
          console.log(result);
        }
        this.closeLectureDialog();
      } else {
        console.log('not pass');
      }
    },
    async onFileChange(file) {
      if (file === undefined) {
        this.pdfFile = file;
        this.urlPDF = '';
        if (this.lectureId) {
          this.urlPDF = this.oldFileUrl;
        }
        return;
      }

      this.pdfFile = file;
      this.urlPDF = await URL.createObjectURL(file);
      var loadingTask = await pdf.createLoadingTask(this.urlPDF);
      await loadingTask.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
    },
    async uploadFile(file) {
      let formData = new FormData();
      console.log(this.numPages);
      /*
        Add the form data we need to submit
      */
      formData.append('fileupload', file);
      formData.append('title', file.name);
      // formData.append('allpage', this.numPages);
      // this.numPages, แก้เป็นส่ง 0 เพียงแค่ชั่วคราวเท่านั้น
      formData.append('allpage', 0);
      /*
        Make the request to the POST /single-file URL
      */
      await axios
        .post(
          `${domain}/uploadfile/private/pdf/course` + '?allpage=' + 0,
          // this.numPages, แก้เป็นส่ง 0 เพียงแค่ชั่วคราวเท่านั้น
          formData,
          {
            headers: {
              ...headersWithTokenForImage(),
            },
          }
        )
        .then(
          async function (response) {
            this.pdfUploadId = response.data.result;
            let resultLink = await getPrivatePdf(this.pdfUploadId);
            this.urlPDF = resultLink;

            this.validate();
          }.bind(this)
        )
        .catch(function (e) {
          console.log('FAILURE!!', e);

          let msg = 'Can not upload document';
          if (e.response != null && e.response.data != null) {
            msg = e.response.data.message;
          }

          EventBus.$emit('snackbar', {
            text: msg,
            dark: true,
            centered: true,
            color: 'error',
          });
        });
    },
    checkToSave() {
      if (this.lectureId) {
        console.log('edit');
        this.title !== this.oldValue.title ||
        this.description !== this.oldValue.description ||
        this.pdfFile
          ? (this.warnningToSaveDialog = true)
          : this.closeLectureDialog();
      } else {
        this.title || this.description || this.pdfFile
          ? (this.warnningToSaveDialog = true)
          : this.closeLectureDialog();
      }
    },
    clearPreview() {
      this.urlPDF = '';
    },
  },
  beforeMount() {},
};
</script>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.textField {
  width: 100%;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 80%;
  min-height: 570px;
  /* width: 200px;
  height: 300px; */
  /* overflow: hidden; */
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
.textAreaDetail {
  border-radius: 15px;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
</style>
